import React from 'react';

const DeleteConfirmationModal = ({ employee, onConfirmDelete, onCancel }) => {
    return (
        <div className="modal-overlay">
            <div className="delete-confirmation-modal">
                <div className="modal-header">
                    <h2>Confirm Delete</h2>
                    <button className="close-btn" onClick={onCancel}>×</button>
                </div>
                <div className="modal-content">
                    <p>Are you sure you want to delete employee <strong>{employee.emp_name}</strong>?</p>
                    <p>This action cannot be undone.</p>
                    <div className="confirmation-actions">
                        <button
                            className="btn-cancel"
                            onClick={onCancel}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn-confirm-delete"
                            onClick={onConfirmDelete}
                        >
                            Delete
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationModal;